import useApiService from 'services/api'
import { AssignModal, AssignModalProps } from './BaseAssignModal'
import { useDataTableContext } from 'components/DataTable'
import { formatInteger } from 'utils/formatting'
import dayjs from 'dayjs'
import { CompanyGPO } from '../../../models/companies'
import { GPOsCell } from 'components/FbUI/StagePill'
import { ManageTagsDistributorsParams } from 'services/common_table_actions'

export default function GPOAssignModal({
  tableObjAccessor = 'gpos',
  apiGPOsAction,
  ...props
}: {
  tableObjAccessor?: string
  apiGPOsAction: (params: ManageTagsDistributorsParams) => Promise<any>
} & Omit<
  AssignModalProps<CompanyGPO, any>,
  | 'apiAction'
  | 'title'
  | 'subtitle'
  | 'pluralLabel'
  | 'singularLabel'
  | 'onConfirmAddNew'
  | 'items'
  | 'tableObjAccessor'
  | 'itemListKey'
>) {
  const api = useApiService()
  const { data: gpos, refetch } = api.useGetGPOs()
  const {
    state: { totalSelectedRows },
  } = useDataTableContext()

  const apiAction = async (params: ManageTagsDistributorsParams) => {
    return await apiGPOsAction(params)
  }

  return (
    <AssignModal
      {...props}
      title="Assign GPOs"
      subtitle={
        <span>
          Choose GPOs to add or remove from{' '}
          <b>{formatInteger(totalSelectedRows)}</b> selected rows.
        </span>
      }
      refetchFn={refetch}
      pluralLabel="GPOs"
      singularLabel="GPO"
      items={gpos ?? []}
      tableObjAccessor={tableObjAccessor!}
      apiAction={apiAction}
      itemListKey="gpo_ids"
      columns={[
        {
          accessorKey: 'name',
          header: 'Name',
        },
        {
          accessorKey: 'created',
          header: 'Date Created',
          cell: (info) => dayjs(info.getValue()).format('MMM DD YYYY'),
          meta: { rightAlign: true },
          size: 100,
        },
      ]}
      tableFooter={(selectedRows) => {
        return (
          <GPOsCell
            nullPlaceholder={<></>}
            gpos={selectedRows}
            maxBadges={Infinity}
            className="items-center justify-center pt-3"
          />
        )
      }}
    />
  )
}
